import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=77fcb58f&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=77fcb58f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fcb58f",
  null
  
)

export default component.exports